import { createContext, useContext } from 'react'
import { useDispatch } from 'react-redux'
import { cookiesKeyNames } from '@revbox/common-fe'
import { useNavigate } from 'react-router-dom'
import { useCookiesContext } from './CookiesContext'
import { clearAdvertiser, setAdvertiser } from '../features/advertiser'
import getCampaing from '../services/adv/get_campaign'
import { encrypt } from '../helpers/crypto'
import { getPublisher } from '../services/pub'
import { generateUserTokenByAdmin, getUserAccount } from '../services/auth'
import { clearUser } from '../features/user'
import { getDefaultPeriods } from '@revbox/helpers-fe'

import { getInventoryCampaign } from '../services/micro'
export const RedirectsContext = createContext()

export default function RedirectsProvider({ children }) {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { cookiesData, updateCookiesProperty, getPathKey } = useCookiesContext()

    const openAdvHomePage = async loginResponse => {
        const publisherId = cookiesData[getPathKey()]?.[cookiesKeyNames.publisherId] || loginResponse?.publisher_id
        const token = cookiesData[getPathKey()]?.[cookiesKeyNames.token] || loginResponse?.token
        const campaignId = loginResponse?.campaign_id
        const { currentPeriod, previousPeriod } = getDefaultPeriods()

        let campaign

        if (token) {
            campaign = await getCampaing(campaignId, token)
        } else {
            campaign = await getCampaing(campaignId)
        }

        if (!campaign.success) {
            const inventory_campaign = await getInventoryCampaign(campaignId)
            const campaign_id = inventory_campaign.data.campaign_id
            campaign = await getCampaing(Number(campaign_id))
        }

        const advId = campaign.data.account_id

        getPublisher(publisherId)
            .then(res => {
                const publisher = res.data

                clearAdvertiser()
                dispatch(
                    setAdvertiser({
                        id: advId
                    })
                )

                updateCookiesProperty(cookiesKeyNames.token, token, advId)
                updateCookiesProperty(cookiesKeyNames.advertiserId, advId, advId)
                updateCookiesProperty(cookiesKeyNames.sidebarSkin, 'advertiser', advId)
                updateCookiesProperty(cookiesKeyNames.publisherId, publisher.id, advId)
                updateCookiesProperty(cookiesKeyNames.currentPeriod, currentPeriod, advId)
                updateCookiesProperty(cookiesKeyNames.previousPeriod, previousPeriod, advId)

                const encryptedAdvId = encrypt(advId)

                const navigateLink = '/adv/home?pub=' + publisher.abbreviation + '&advId=' + encryptedAdvId

                window.location.href = navigateLink
            })
            .catch(err => {
                console.log(err)
            })
    }

    const openCampaignAdvAunctions = async campaignId => {
        const publisherId = cookiesData[getPathKey()]?.[cookiesKeyNames.publisherId]
        const { currentPeriod, previousPeriod } = getDefaultPeriods()

        let campaign = await getCampaing(campaignId)
        if (!campaign.success) {
            const inventory_campaign = await getInventoryCampaign(campaignId)
            const campaign_id = inventory_campaign.data.campaign_id
            campaign = await getCampaing(Number(campaign_id))
        }

        const advId = campaign.data.account_id

        getPublisher(publisherId)
            .then(res => {
                const publisher = res.data
                const api_key = publisher.api_key
                const old_token = cookiesData[getPathKey()]?.[cookiesKeyNames.token]
                const skinMode = cookiesData[getPathKey()]?.[cookiesKeyNames.skinMode]

                updateCookiesProperty(cookiesKeyNames.publisherToken, old_token)

                clearUser()
                clearAdvertiser()

                dispatch(
                    setAdvertiser({
                        id: advId
                    })
                )

                updateCookiesProperty(cookiesKeyNames.token, old_token, advId)
                updateCookiesProperty(cookiesKeyNames.advertiserId, advId, advId)
                updateCookiesProperty(cookiesKeyNames.sidebarSkin, 'advertiser', advId)
                updateCookiesProperty(cookiesKeyNames.publisherId, publisher.id, advId)
                updateCookiesProperty(cookiesKeyNames.currentPeriod, currentPeriod, advId)
                updateCookiesProperty(cookiesKeyNames.previousPeriod, previousPeriod, advId)
                updateCookiesProperty(cookiesKeyNames.skinMode, skinMode, advId)

                const encryptedAdvId = encrypt(advId)

                const navigateLink =
                    '/adv/campaign/ppc?campaignId=' + campaign.data.id + '&pub=' + publisher.abbreviation + '&advId=' + encryptedAdvId

                window.open(navigateLink, '_blank')

                generateUserTokenByAdmin(api_key)
                    .then(user_token => {
                        const token = user_token.data.token
                        clearUser()
                        clearAdvertiser()
                        updateCookiesProperty(cookiesKeyNames.currentPeriod, currentPeriod)
                        updateCookiesProperty(cookiesKeyNames.previousPeriod, previousPeriod)
                        updateCookiesProperty(cookiesKeyNames.token, token, advId)
                        updateCookiesProperty(cookiesKeyNames.advertiserId, advId, advId)
                        updateCookiesProperty(cookiesKeyNames.sidebarSkin, 'advertiser', advId)
                        updateCookiesProperty(cookiesKeyNames.publisherId, publisher.id, advId)

                        getUserAccount(advId)
                            .then(account => {
                                dispatch(
                                    setAdvertiser({
                                        id: account.data.id
                                    })
                                )
                                updateCookiesProperty(cookiesKeyNames.advertiserId, account.data.id, advId)

                                const navigateLink = '/adv/home?pub=' + publisher.abbreviation + '&advId=' + account.data.id

                                window.open(navigateLink, '_blank')
                            })
                            .catch(err => {
                                console.log(err)
                            })
                    })
                    .catch(err => {
                        console.log(err)
                    })
            })
            .catch(err => {
                console.log(err)
            })
    }

    const openCampaignAdvAnalytics = async campaignId => {
        let campaign = await getCampaing(campaignId)
        if (!campaign.success) {
            const inventory_campaign = await getInventoryCampaign(campaignId)
            const campaign_id = inventory_campaign.data.campaign_id
            campaign = await getCampaing(Number(campaign_id))
        }

        const advId = campaign.data.account_id

        clearAdvertiser()
        updateCookiesProperty(cookiesKeyNames.sidebarSkin, 'advertiser')
        updateCookiesProperty(cookiesKeyNames.publisherToken, cookiesData[getPathKey()]?.[cookiesKeyNames.token], advId)
        updateCookiesProperty(cookiesKeyNames.publisherId, cookiesData['pub']?.[cookiesKeyNames.publisherId], advId)

        dispatch(
            setAdvertiser({
                id: advId
            })
        )
        updateCookiesProperty(cookiesKeyNames.advertiserId, advId, advId)

        const encryptedAdvId = encrypt(advId)

        window.open('/adv/campaign/analytics?campaignId=' + campaign.data.id + '&advId=' + encryptedAdvId, '_blank')
    }

    const openCampaignEdit = async campaignId => {
        let campaign = await getCampaing(campaignId)
        if (!campaign.success) {
            const inventory_campaign = await getInventoryCampaign(campaignId)
            const campaign_id = inventory_campaign.data.campaign_id
            campaign = await getCampaing(Number(campaign_id))
        }

        navigate('/pub/customer/campaign/edit?id=' + campaign.data.id)
    }

    return (
        <RedirectsContext.Provider
            value={{
                openCampaignAdvAunctions,
                openCampaignAdvAnalytics,
                openCampaignEdit,
                openAdvHomePage
            }}
        >
            {children}
        </RedirectsContext.Provider>
    )
}

export const useRedirectsContext = () => useContext(RedirectsContext)
